import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import NetworkConnectionManager from './lib/networkConnectionManager'
import { NM_ONLINE, NM_OFFLINE } from './store/mutation-types'

const networkConnectionManager = new NetworkConnectionManager(store, NM_ONLINE, NM_OFFLINE)

// bootstrap
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
